const stripTrailingDot = (value) => String(value ?? "").replace(/\.+$/, "");

export const formatSerialNumber = (value) => {
  const serial = stripTrailingDot(value);
  return serial ? `${serial}.` : "";
};

export const getChildSerialNumber = (parent, index) => {
  const parentSerial = stripTrailingDot(parent);
  return formatSerialNumber(
    parentSerial ? `${parentSerial}.${index + 1}` : index + 1,
  );
};

export const getLetterMarker = (index) =>
  `${String.fromCharCode(97 + index)})`;

export const numberClauseTree = (clauses = [], parentSerial = "") =>
  clauses.map((clause, index) => {
    const number = getChildSerialNumber(parentSerial, index);
    return {
      ...clause,
      number,
      clauses: numberClauseTree(clause.clauses, number),
      subContent: numberClauseTree(clause.subContent, number),
    };
  });
